"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollUp;

var _react = require("react");

var _useScrollRelative = _interopRequireDefault(require("./internal/useScrollRelative"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollUp() {
  var scrollRelative = (0, _useScrollRelative.default)();
  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelative.apply(void 0, ['up'].concat(args));
  }, [scrollRelative]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTY3JvbGxVcCIsInNjcm9sbFJlbGF0aXZlIiwidXNlU2Nyb2xsUmVsYXRpdmUiLCJ1c2VDYWxsYmFjayIsImFyZ3MiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxVcC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDYWxsYmFjayB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVNjcm9sbFJlbGF0aXZlIGZyb20gJy4vaW50ZXJuYWwvdXNlU2Nyb2xsUmVsYXRpdmUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTY3JvbGxVcCgpOiAob3B0aW9ucz86IHsgZGlzcGxhY2VtZW50OiBudW1iZXIgfSkgPT4gdm9pZCB7XG4gIGNvbnN0IHNjcm9sbFJlbGF0aXZlID0gdXNlU2Nyb2xsUmVsYXRpdmUoKTtcblxuICByZXR1cm4gdXNlQ2FsbGJhY2soKC4uLmFyZ3MpID0+IHNjcm9sbFJlbGF0aXZlKCd1cCcsIC4uLmFyZ3MpLCBbc2Nyb2xsUmVsYXRpdmVdKTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsV0FBVCxHQUFxRTtFQUNsRixJQUFNQyxjQUFjLEdBQUcsSUFBQUMsMEJBQUEsR0FBdkI7RUFFQSxPQUFPLElBQUFDLGtCQUFBLEVBQVk7SUFBQSxrQ0FBSUMsSUFBSjtNQUFJQSxJQUFKO0lBQUE7O0lBQUEsT0FBYUgsY0FBYyxNQUFkLFVBQWUsSUFBZixTQUF3QkcsSUFBeEIsRUFBYjtFQUFBLENBQVosRUFBd0QsQ0FBQ0gsY0FBRCxDQUF4RCxDQUFQO0FBQ0QifQ==